import { useTranslation } from '@thoughtspot/i18n';
import { ErrorCode } from '@thoughtspot/radiant-react/widgets/alert/alert-constants';
import { MutedAlert } from '@thoughtspot/radiant-react/widgets/alert/muted/muted-alert';
import { Horizontal } from '@thoughtspot/radiant-react/widgets/layout';
import _ from 'lodash';
import React, { useState } from 'react';
import styles from '../../styles/chart.module.scss';
import { ErrorDetailsModal } from './chart-error-modal';
export const ChartErrorComponent = ({ errorTitle, errorDescription, errorDetail, errorCode = ErrorCode.LOCAL_VISUALIZATION, shouldShowErrorImage = true, shouldShowErrorDetail = false, shouldShowErrorDescription = true, ErrorMsgCode, }) => {
    const { t } = useTranslation();
    const [isErrorDetailsModalOpen, setErrorDetailsModalOpen] = useState(false);
    if (_.isEmpty(errorTitle)) {
        return null;
    }
    const errors = {
        errorTitle,
        errorDescription,
        errorDetail,
        errorCode,
        ErrorMsgCode,
        shouldShowErrorDetail,
        shouldShowErrorDescription,
    };
    const primaryLink = {
        label: t('answer.errorDetailsModal.buttonLabel.seeDetails'),
        onClick: () => {
            setErrorDetailsModalOpen(true);
        },
        type: 'tertiary',
        className: styles.errorVizActionButton,
    };
    return (React.createElement("div", { className: `${styles.chartErrorComponent}`, "data-testid": "custom-chart-error" },
        React.createElement(Horizontal, { vAlignContent: "center", hAlignContent: "center", minHeight: "100%", width: "100%", className: "chartVizNoDataErrorSection" },
            React.createElement(MutedAlert, { imageVisible: shouldShowErrorImage, errorCode: errorCode, title: errorTitle, primaryAction: shouldShowErrorDetail ? primaryLink : null, description: shouldShowErrorDescription ? errorDescription : null })),
        shouldShowErrorDetail ? (React.createElement(ErrorDetailsModal, { isOpen: isErrorDetailsModalOpen, onClose: () => setErrorDetailsModalOpen(false), errors: errors })) : null));
};
//# sourceMappingURL=chart-error.component.js.map